<template>
	<Popover
		v-model:visible="dropdownVisible"
		:placement="placement"
		overlayClassName="locale-chooser"
		:color="bgDefault"
		trigger="click"
	>
		<template #content>
			<a v-for="item in localeChoices" class="locale-choice" :key="item.value" @click="changeLocale(item.value)">
				<div class="locale-choice-label">{{ item.label }}</div>
			</a>
		</template>
		<button type="button" class="menu-item-container">
			<div class="locale-label">{{ abbr }}</div>
			<GlobalOutlined class="locale-icon" />
		</button>
	</Popover>
</template>

<script>
import { computed, ref } from 'vue';
import { Popover } from 'ant-design-vue';
import { GlobalOutlined } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';

import { useSessionStore } from '@/stores/session';

import { useSmallScreen } from '@/utils/useSmallScreen';
import { localeSettings, getLocaleData } from '@/locales/locales';
import { useLocaleData } from '@/locales/useLocaleData';


export default {
	components: {
		Popover, GlobalOutlined,
	},
	setup() {
		const { smallScreen } = useSmallScreen();
		const placement = computed(() => smallScreen.value ? 'leftBottom' : 'bottomRight');
		const { localeData } = useLocaleData();
		const abbr = computed(() => localeData.value.abbr);
		const localeChoices = computed(() => localeSettings);
		const dropdownVisible = ref(false);
		const sessionStore = useSessionStore();
		const changeLocale = label => {
			const data = getLocaleData(label);
			sessionStore.updateLocale(data.value);
			dropdownVisible.value = false;
		}
		return {
			placement,
			abbr,
			localeChoices,
			dropdownVisible,
			changeLocale,
			bgDefault: Consts.COLORS.dark0,
		}
	},
}
</script>
<style>
.locale-chooser .ant-popover-inner-content {
	padding: 8px 0;
}
</style>

<style scoped>
.menu-item-container {
	appearance: none;
	display: block;
	position: relative;
	aspect-ratio: 1 / 1;
	cursor: pointer;
	margin: 8px;
	padding: 8px 8px 5px 8px;
	border: none;
	border-radius: 6px;
	font: inherit;
	line-height: inherit;
	text-align: inherit;
	color: white;
	width: 40px;
	height: 40px;
	background-color: v-bind(bgDefault);
	font-size: 12px;
	overflow: hidden;
	box-shadow: rgba(0,0,0,0.5) 0px 1px 5px;
}

.menu-item-container::-moz-focus-inner {
	border: 0;
	padding: 0;
}

.menu-item-container:hover {
	background-color: var(--ant-primary-color, #1890ff);
	box-shadow: rgba(14, 27, 133, 0.5) 0px 1px 5px;
}

@media (max-width: 900px) {
	.menu-item-container {
		font-size: 10px;
		width: 34px;
		height: 35px;
	}
}

.locale-label {
	position: absolute;
	inset-block-start: 0px;
	inset-inline-end: 4px;
	inset-inline-start: 4px;
	color: white;
	font-weight: bold;
	text-shadow: 0 0 2px black;
}

.locale-icon {
	position: absolute;
	inset-block-start: 16px;
	inset-inline-start: 15px;
	font-size: 30px;
}

.locale-choice {
	display: flex;
	gap: 8px;
	padding: 8px 16px;
	align-items: center;
	color: white;
}

.locale-choice:hover {
	background-color: var(--ant-primary-color, #1890ff);
}
</style>
